var _desc, _defs, _rect, _rect2, _rect3, _line, _line2, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgApsSecurityDashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 900 560",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "APS Security dashboard thumbnail") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "desc"
  }, "Dark cybersecurity scanning dashboard with live console, finding log, and teal status indicators.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#111827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55%",
    stopColor: "#0f1419"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#050707"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "teal",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#2dd4bf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#00a889"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "glow",
    x: "-80%",
    y: "-80%",
    width: "260%",
    height: "260%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "blur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 900,
    height: 560,
    fill: "url(#bg)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 150,
    height: 560,
    fill: "#121416"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 0,
    width: 750,
    height: 560,
    fill: "#171717",
    opacity: 0.75
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 150,
    y1: 0,
    x2: 150,
    y2: 560,
    stroke: "#2a2f34"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 150,
    y1: 78,
    x2: 900,
    y2: 78,
    stroke: "#2a2f34"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fontFamily: "Arial, Helvetica, sans-serif"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 40,
    r: 19,
    fill: "url(#teal)",
    filter: "url(#glow)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38 28l9 4v8c0 8-5 12-9 14-4-2-9-6-9-14v-8z",
    fill: "#eafffb"
  }), /*#__PURE__*/React.createElement("text", {
    x: 70,
    y: 39,
    fill: "#ffffff",
    fontSize: 18,
    fontWeight: 800
  }, "APS Security"), /*#__PURE__*/React.createElement("text", {
    x: 70,
    y: 58,
    fill: "#7d8790",
    fontSize: 12
  }, "Pentest Platform"), /*#__PURE__*/React.createElement("text", {
    x: 28,
    y: 130,
    fill: "#727b84",
    fontSize: 12,
    fontWeight: 700,
    letterSpacing: 3
  }, "MAIN"), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 186,
    width: 118,
    height: 40,
    rx: 6,
    fill: "#123d35"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 186,
    width: 4,
    height: 40,
    rx: 2,
    fill: "#17d7be"
  }), /*#__PURE__*/React.createElement("text", {
    x: 52,
    y: 211,
    fill: "#18dcc2",
    fontSize: 16,
    fontWeight: 800
  }, "Scans"), /*#__PURE__*/React.createElement("text", {
    x: 52,
    y: 162,
    fill: "#aeb6bd",
    fontSize: 15
  }, "Dashboard"), /*#__PURE__*/React.createElement("text", {
    x: 52,
    y: 255,
    fill: "#aeb6bd",
    fontSize: 15
  }, "Schedule"), /*#__PURE__*/React.createElement("text", {
    x: 28,
    y: 320,
    fill: "#727b84",
    fontSize: 12,
    fontWeight: 700,
    letterSpacing: 3
  }, "SYSTEM"), /*#__PURE__*/React.createElement("text", {
    x: 52,
    y: 360,
    fill: "#aeb6bd",
    fontSize: 15
  }, "Notifications"), /*#__PURE__*/React.createElement("text", {
    x: 52,
    y: 400,
    fill: "#aeb6bd",
    fontSize: 15
  }, "Settings"), /*#__PURE__*/React.createElement("text", {
    x: 178,
    y: 43,
    fill: "#d5dce2",
    fontSize: 18
  }, "Scan / Private Assets /"), /*#__PURE__*/React.createElement("text", {
    x: 375,
    y: 43,
    fill: "#ffffff",
    fontSize: 18,
    fontWeight: 800
  }, "New Scan"), /*#__PURE__*/React.createElement("rect", {
    x: 770,
    y: 22,
    width: 98,
    height: 34,
    rx: 6,
    fill: "#101010",
    stroke: "#30363d"
  }), /*#__PURE__*/React.createElement("text", {
    x: 786,
    y: 44,
    fill: "#ffffff",
    fontSize: 13,
    fontWeight: 800
  }, "Export Report"), /*#__PURE__*/React.createElement("circle", {
    cx: 205,
    cy: 142,
    r: 39,
    fill: "none",
    stroke: "#22d3bb",
    strokeWidth: 8,
    filter: "url(#glow)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 205,
    y: 145,
    fill: "#ffffff",
    fontSize: 19,
    fontWeight: 900,
    textAnchor: "middle"
  }, "100%"), /*#__PURE__*/React.createElement("text", {
    x: 205,
    y: 162,
    fill: "#808993",
    fontSize: 10,
    textAnchor: "middle"
  }, "In Progress"), /*#__PURE__*/React.createElement("circle", {
    cx: 286,
    cy: 134,
    r: 25,
    fill: "url(#teal)",
    filter: "url(#glow)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 286,
    y: 140,
    fill: "#ffffff",
    fontSize: 21,
    textAnchor: "middle"
  }, "\u263C"), /*#__PURE__*/React.createElement("text", {
    x: 286,
    y: 184,
    fill: "#15d9c0",
    fontSize: 14,
    fontWeight: 800,
    textAnchor: "middle"
  }, "Spidering"), /*#__PURE__*/React.createElement("g", {
    stroke: "#33373a",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("line", {
    x1: 332,
    y1: 134,
    x2: 466,
    y2: 134
  }), /*#__PURE__*/React.createElement("line", {
    x1: 520,
    y1: 134,
    x2: 656,
    y2: 134
  }), /*#__PURE__*/React.createElement("line", {
    x1: 710,
    y1: 134,
    x2: 844,
    y2: 134
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#292b2d"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 493,
    cy: 134,
    r: 25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 683,
    cy: 134,
    r: 25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 871,
    cy: 134,
    r: 25
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#727b84",
    fontSize: 14,
    textAnchor: "middle"
  }, /*#__PURE__*/React.createElement("text", {
    x: 493,
    y: 184
  }, "Testing"), /*#__PURE__*/React.createElement("text", {
    x: 683,
    y: 184
  }, "Validating"), /*#__PURE__*/React.createElement("text", {
    x: 871,
    y: 184
  }, "Reporting")), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 235,
    width: 520,
    height: 220,
    rx: 9,
    fill: "#0d0e0f",
    stroke: "#30363d"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 235,
    width: 520,
    height: 54,
    rx: 9,
    fill: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 196,
    cy: 263,
    r: 5,
    fill: "#17d7be"
  }), /*#__PURE__*/React.createElement("text", {
    x: 211,
    y: 270,
    fill: "#ffffff",
    fontSize: 18,
    fontWeight: 900
  }, "Live Scan Console"), /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 251,
    width: 85,
    height: 25,
    rx: 12,
    fill: "#0b4a42"
  }), /*#__PURE__*/React.createElement("text", {
    x: 337,
    y: 268,
    fill: "#16f0cf",
    fontSize: 13,
    fontWeight: 800
  }, "Running..."), /*#__PURE__*/React.createElement("text", {
    x: 198,
    y: 322,
    fill: "#828b94",
    fontSize: 13
  }, "[09:04:00]"), /*#__PURE__*/React.createElement("text", {
    x: 304,
    y: 322,
    fill: "#cfd3d8",
    fontSize: 14,
    fontWeight: 700
  }, "POST blocked on"), /*#__PURE__*/React.createElement("rect", {
    x: 420,
    y: 306,
    width: 104,
    height: 22,
    rx: 4,
    fill: "#073d38"
  }), /*#__PURE__*/React.createElement("text", {
    x: 430,
    y: 322,
    fill: "#1ee8ca",
    fontSize: 14,
    fontWeight: 900
  }, "/password/test"), /*#__PURE__*/React.createElement("text", {
    x: 198,
    y: 362,
    fill: "#828b94",
    fontSize: 13
  }, "[09:06:00]"), /*#__PURE__*/React.createElement("text", {
    x: 304,
    y: 362,
    fill: "#ffd200",
    fontSize: 14,
    fontWeight: 900
  }, "Accessed dashboard with X-UserId header."), /*#__PURE__*/React.createElement("text", {
    x: 198,
    y: 402,
    fill: "#828b94",
    fontSize: 13
  }, "[09:08:00]"), /*#__PURE__*/React.createElement("text", {
    x: 304,
    y: 402,
    fill: "#ff6262",
    fontSize: 14,
    fontWeight: 900
  }, "SQL injection confirmed in authentication endpoint."), /*#__PURE__*/React.createElement("rect", {
    x: 716,
    y: 235,
    width: 164,
    height: 220,
    rx: 9,
    fill: "#1d1d1d",
    stroke: "#30363d"
  }), /*#__PURE__*/React.createElement("text", {
    x: 734,
    y: 270,
    fill: "#ffffff",
    fontSize: 18,
    fontWeight: 900
  }, "Finding Log"), /*#__PURE__*/React.createElement("rect", {
    x: 734,
    y: 302,
    width: 128,
    height: 62,
    rx: 8,
    fill: "#171717",
    stroke: "#30363d"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 746,
    y: 316,
    width: 27,
    height: 27,
    rx: 5,
    fill: "#481e1e"
  }), /*#__PURE__*/React.createElement("text", {
    x: 756,
    y: 335,
    fill: "#ff5252",
    fontSize: 15,
    fontWeight: 900
  }, "0"), /*#__PURE__*/React.createElement("text", {
    x: 746,
    y: 387,
    fill: "#ffffff",
    fontSize: 13,
    fontWeight: 900
  }, "SQL Injection"), /*#__PURE__*/React.createElement("text", {
    x: 746,
    y: 410,
    fill: "#18dcc2",
    fontSize: 12,
    fontWeight: 900
  }, "/api/users/profile"), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 475,
    width: 702,
    height: 44,
    fill: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("text", {
    x: 195,
    y: 503,
    fill: "#16d7c0",
    fontSize: 13
  }, "Sub-Agents:"), /*#__PURE__*/React.createElement("text", {
    x: 280,
    y: 503,
    fill: "#ffffff",
    fontSize: 13,
    fontWeight: 900
  }, "0"), /*#__PURE__*/React.createElement("text", {
    x: 358,
    y: 503,
    fill: "#16d7c0",
    fontSize: 13
  }, "Parallel Executions:"), /*#__PURE__*/React.createElement("text", {
    x: 496,
    y: 503,
    fill: "#ffffff",
    fontSize: 13,
    fontWeight: 900
  }, "2"), /*#__PURE__*/React.createElement("rect", {
    x: 704,
    y: 489,
    width: 25,
    height: 22,
    rx: 5,
    fill: "#481e1e"
  }), /*#__PURE__*/React.createElement("text", {
    x: 713,
    y: 505,
    fill: "#ff5252",
    fontSize: 12,
    fontWeight: 900
  }, "5"), /*#__PURE__*/React.createElement("text", {
    x: 736,
    y: 504,
    fill: "#cfd3d8",
    fontSize: 13
  }, "Critical"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApsSecurityDashboard);
export default __webpack_public_path__ + "static/media/aps-security-dashboard.beea5fbf94f8e6cf520bcbd9db6cecfc.svg";
export { ForwardRef as ReactComponent };